import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is via httpOnly cookie set by the backend on login/register.
// We do NOT cache the token in any web-accessible storage (XSS risk).
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Non-sensitive flag used by the UI to decide whether to call /auth/me
// on first load. Cleared on logout / 401 / explicit sign-out.
export const AUTHED_FLAG = "uce_authed";

export function fmtINR(n) {
    if (n == null) return "₹0";
    return "₹" + Math.round(Number(n)).toLocaleString("en-IN");
}

export function errMsg(e) {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
    return e?.message || "Something went wrong";
}
